import { Spinny } from "../components/Spinny";
import { msalInstance } from "../settings/authSettings";
import * as microsoftTeams from "@microsoft/teams-js";
import { useEffect } from "react";
import * as msal from "@azure/msal-browser";

export default function SilentStart() {
    const msal = msalInstance;

    useEffect(() => {
        microsoftTeams.app.initialize().then(() => {
            // Get the tab context, and use the information to navigate to Azure AD login page
            microsoftTeams.app.getContext().then(async (context) => {


                var request = {
                    scopes: ["openid", "profile"],
                    loginHint: context.user?.loginHint
                };

                console.log("Starting silent sign-in with request:", msal.getConfiguration(), request);

                await msal.initialize();
                await msal.loginRedirect(request);
            });
        });
    }, []);

    return <div><Spinny text={`Silent-Start: Processing sign-in response…`} />
    </div>;
}